import { useModalNavigation, useParams } from '@exam-management/router';
import { type ButtonProps, Button, AddRoundedIcon } from '@shared/components';

export function CreateQConfigButton(props: Readonly<ButtonProps>) {
  const { courseId } = useParams('/exam-courses/:courseId/qconfigs');

  const { open } = useModalNavigation('/exam-courses/:courseId/qconfigs', '/create-qconfig', {
    open: {
      params: {
        courseId,
      },
    },
  });

  const handleClick = () => {
    open();
  };

  return (
    <Button startIcon={<AddRoundedIcon />} onClick={handleClick} {...props}>
      Create QConfig
    </Button>
  );
}
